import { ISVGProps } from '@alinta-digital/asg';
import React from 'react';

export function ChevronRightIcon(props: ISVGProps): JSX.Element {
  return (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.44722 6.32299C7.4374 6.35217 7.42621 6.38098 7.41365 6.40933C7.36471 6.51943 7.2952 6.62261 7.20499 6.71293V6.7132L2.2195 11.7046C1.82615 12.0985 1.18841 12.0985 0.795069 11.7046L0.795009 11.7046C0.401664 11.3108 0.401664 10.6723 0.795009 10.2785L5.06837 6L0.795009 1.72155C0.401664 1.32773 0.401664 0.689235 0.795009 0.295421L0.795069 0.29536C1.18841 -0.0984534 1.82615 -0.0984534 2.2195 0.29536L7.20499 5.2868L7.20522 5.28703C7.40163 5.48395 7.49997 5.74197 7.5 6L7.44722 6.32299Z"
        fill="#196CFF"
      />
    </svg>
  );
}
